/* Uso del menu */
import create from "zustand"; // para generar un store con los elementos de entrada

const menuStore = create ((set, get:any) => ({

   //menú completo del SSC  
    menuStore:[
        { id: 0, cveA:'P',  pagina: 'P',  errorPagina: false, desc:'Propuesta', clavesRol:[0,1,2,3,4] },
        { id: 1, cveA:'RP', pagina: 'RP', errorPagina: false, desc:'Responsable de Proceso', clavesRol:[2] },
        { id: 2, cveA:'RD', pagina: 'RD', errorPagina: false, desc:'Responsable de Diseño',  clavesRol:[3] },
        { id: 3, cveA:'TC', pagina: 'TC', errorPagina: false, desc:'Tablero de control', clavesRol:[1,2,3] },
        { id: 4, cveA:'C',  pagina: 'C',  errorPagina: false, desc:'Configuración', clavesRol:[2] }
      ],  
      
    //guarda menu parcial (en su caso) a visualrizar con los elementos de autorización según el tipo de usuario
    menuxRolStore: [], 

    //página activa según el menu en el que se encuentre
    paginaActivaStore: '',

    generaMenuxRolStore: async (roles:any) => {
      //alert('menu.store - generaMenuxRolStore' );
      console.clear();
      console.log('generaMenuxRolStore - roles (entrada):', roles)

      let menus = get().menuStore;
      let pasoMenu=[];    
      //primer elemento siempre entra
        let elemMenu = { key:0, id: menus[0].id, cveA: menus[0].cveA, desc: menus[0].desc, activo:false, pagina:menus[0].pagina};
        pasoMenu.push(elemMenu); 
      
      //console.log('*roles.length: ',roles.length)
      if (roles.length == 1 && (roles[0]==0 || roles[0]==4 )){
            pasoMenu[0].activo = true;
            set({ paginaActivaStore: 'P' }); 
      }
      else {
            let swRP = false;
            let swRD = false;
            let swUS = false;
            roles.map((r:any, index:any) => {
                let x:any={};
                x =  { key:r, id: menus[r].id, cveA:menus[r].cveA, desc:menus[r].desc, activo:false, pagina:menus[r].pagina};
                switch(r){
                    case 1: swRP=true;  break;
                    case 2: swRD=true;  break;
                    case 3: swUS=true;  break;
                }
                if (x.id != 4 ) { //esta la lo pusimos fijo en la línea 43
                    if (x.id==1){
                        x.activo = true;
                        set({ paginaActivaStore: 'RP' }); 
                    }
                    if (x.id==2 && swRP==false){  
                        x.activo = true; 
                        set({ paginaActivaStore: 'RD' }); 
                    }
                    if (x.id==3 && (swRP==false && swRD==false)) {
                        x.activo = true; 
                        set({ paginaActivaStore: 'TC' }); 
                    }
                    pasoMenu.push(x);
                    //console.log('::::x', x)
                }
            }); 
            console.log('::::swRP', swRP, 'swRD', swRD, 'swUS', swUS)
            //tablero de control para rp, rd y us
            if (swUS == false) {
                if (swRP || swRD ) { //|| swUS
                let elemMenu = { key:3, id: menus[3].id, cveA: menus[3].cveA, desc: menus[3].desc, activo:false, pagina:menus[3].pagina};
                pasoMenu.push(elemMenu); 
                }
            }
            //configuraciones solo rp
            if (swRP){
               let elemMenu = { key:4, id: menus[4].id, cveA: menus[4].cveA, desc: menus[4].desc, activo:false, pagina:menus[4].pagina};
               pasoMenu.push(elemMenu); 
            };
      }
      
      set({ menuxRolStore: pasoMenu }); 
      //console.log('***pasoMenu:', pasoMenu);
      //console.log('***menuxRolStore:', get().menuxRolStore);
      //console.log('***paginaActivaStore:', get().paginaActivaStore);
      console.clear();
    },

    cambiaMenu: async (menuSel:any) => {
        //alert('menu.store - generaMenuxRolStore' );
        //console.log('cambiaMenu - menuSel:', menuSel.item)
  
        let menus = get().menuxRolStore;
        
        if (menus.length > 0) {
              menus.map((m:any, index:any) => {
                  //console.log('m.id: ', m.id, ' menuSel.item.id:',menuSel.item.id )
                  m.activo = false;
                  if (menuSel.item.id == m.id){
                      m.activo = true
                      set({ paginaActivaStore: m.pagina }); 
                  }
              }); 
        }
        set({ menuxRolStore: menus }); 
        //console.log('***generaMenuxRolStore - pasoMenu:', pasoMenu)
        //console.log('***cambiaMenu - menuxRolStore:', get().menuxRolStore)
        //console.log('***cambiaMenu - paginaActivaStore:', get().paginaActivaStore)
    }, 

    cambiaErrorPagina: async (menuSel:any, datoError:any) => {
        //alert('menu.store - cambiaErrorPagina' + menuSel );
        //console.log('cambiaErrorPagina - menuSel: ', menuSel, ' datoError: ', datoError )
        let menus = get().menuStore;
        menus.map((m:any, indexM:any) => {
            if (m.pagina == menuSel) 
                m.errorPagina = datoError
        }); 
        set({ menuStore: menus }); 
        //console.log('***cambiaErrorPagina - menuStore:', get().menuStore)
    },

    quitaErrorPagina: async () => {
        //console.log('quitaErrorPagina - menuSel: ' )
        let menus = get().menuStore;
        menus.map((m:any, indexM:any) => {
            m.errorPagina = false
        }); 
        set({ menuStore: menus }); 
        //console.log('***quitaErrorPagina - menuStore:', get().menuStore)
    }

   
}));

export default menuStore;
